import React from 'react'
import { useTranslation } from '@mc/i18n'
import { Locations } from '@mc/track-event'
import EnterpriseCTA from 'components/EnterpriseCTA'

interface CalloutProps {
  pageSource: string
  location: typeof Locations.NAVIGATION
  scrollToForm: boolean
  href: string
}

export const Callout = ({
  pageSource,
  location,
  scrollToForm,
  href,
}: CalloutProps) => {
  const { t } = useTranslation('@mc/next')

  return (
    <div className='container d-flex flex-column flex-fill justify-content-end mc-p-4 mc-text--center'>
      <div className='d-flex flex-column align-items-center mc-bg-container-tint-medium mc-p-4 mc-corners--md'>
        <h2 className='mc-text-h5 mc-mb-2'>
          {t('nav.mobileMenuCallout.title')}
        </h2>
        <p className='mc-mb-5'>{t('nav.mobileMenuCallout.subtitle')}</p>
        <EnterpriseCTA
          pageSource={pageSource}
          location={location}
          scrollToForm={scrollToForm}
          href={href}
        />
      </div>
    </div>
  )
}

export default Callout
